import React, { Component } from "react";
import "./App.css";
import Page from "./components/Viewer";
// import "bootstrap/dist/css/bootstrap.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
// import { TransitionGroup } from "react-transition-group";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appearHome: true,
      extract_opacity: 1,
      current_page: 0,
      show_helptext: false,
      payload: [
        {
          page_number: 1,
          page_image: null,
          extract_image: null
        }
      ]
    };
  }

  ShortCuts = key => {
    switch (key.key) {
      case "ArrowRight":
        if (this.state.current_page < this.state.payload.length - 1) {
          this.setState({
            current_page: this.state.current_page + 1,
            extract_opacity: 1
          });
        }
        break;
      case "ArrowLeft":
        if (this.state.current_page !== 0) {
          this.setState({
            current_page: this.state.current_page - 1,
            extract_opacity: 1
          });
        }

        break;

      case "b":
        this.setState({ extract_opacity: 0 });
        break;
      case "m":
        this.setState({ extract_opacity: 1 });
        break;
      default:
        break;
    }
  };

  Toggler(e) {
    this.setState({ extract_opacity: 1 * e.target.value * 0.01 });
  }

  PageNavigator = step => {
    switch (step) {
      case -1:
        if (this.state.current_page !== 0) {
          this.setState({
            current_page: this.state.current_page - 1,
            extract_opacity: 1
          });
        }
        break;
      case 1:
        if (this.state.current_page < this.state.payload.length - 1) {
          this.setState({
            current_page: this.state.current_page + 1,
            extract_opacity: 1
          });
        }
        break;
      default:
        break;
    }
  };

  componentDidMount() {
    axios
      .get("/api/pages/")
      .then(response => {
        this.setState({ payload: [...response.data] });
      })
      .catch(err => {
        console.log(err);
      });
  }
  render() {
    window.addEventListener("keydown", this.ShortCuts, false);
    var helpText = (
      <div className="helptext lead p-4">
        <div>
          <button
            id="close"
            className="btn btn-secondary float-right"
            onClick={() => {
              this.setState({ show_helptext: false });
            }}
          >
            Close
          </button>
        </div>
        <div className="p-4">
          <h3>
            <u>Anna Julia Cooper Reader Shortcuts</u>
          </h3>
          <ul>
            <li>
              <b>"b" : Hide Magazine Extract</b>
            </li>
            <li>
              <b>"m" : Show Magazine Extract</b>
            </li>
            <li>
              <b>"&gt;" : Right, Next Page</b>
            </li>
            <li>
              <b>"&lt;" : Left, Previous Page</b>
            </li>
          </ul>
          <p>
            Note: Slide the slider on top right above to hide or show extracts
          </p>
        </div>
      </div>
    );

    return (
      <div className="container-fluid m-0 p-0" id="top">
        {document.addEventListener(
          "contextmenu",
          e => {
            e.preventDefault();
          },
          false
        )}

        <div className="container-fluid m-0 p-3 text-center headliner lead">
          <div className="spaced">
            <b>Pg.{this.state.current_page + 1}</b>
          </div>
          <div className="spaced">
            <h1 className="header">A.J. Cooper Scrapbook Reader.</h1>
          </div>
          <div className="spaced slide-head">
            <span>
              Extract {parseInt(this.state.extract_opacity * 100)} % visible
            </span>
            <input
              style={{ color: "brown" }}
              type="range"
              max="100"
              className="slider"
              onChange={e => this.Toggler(e)}
              value={this.state.extract_opacity * 100}
            />
          </div>
          <div className="spaced pt-2">
            <button
              className=" btn btn-outline-secondary"
              onClick={() => {
                if (this.state.show_helptext === true) {
                  this.setState({ show_helptext: false });
                } else {
                  this.setState({ show_helptext: true });
                }
              }}
            >
              Help
            </button>
          </div>
        </div>

        <div className="spacer" />
        <div
          className="left"
          onClick={() => {
            this.PageNavigator(-1);
          }}
        >
          <div className="right-wrapper">
            <h1>&laquo;</h1>
          </div>
        </div>

        {this.state.show_helptext === true ? helpText : null}

        <Page
          property={this.state.payload[this.state.current_page]}
          opacity={this.state.extract_opacity}
        />

        <div
          className="right"
          id="right"
          onClick={() => {
            this.PageNavigator(1);
          }}
        >
          <div className="right-wrapper">
            <h1>&raquo;</h1>
          </div>
        </div>
        <div className="spacer" />
      </div>
    );
  }
}

export default App;
